import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Kiosk from '@components/kioskCart';
import Loader from '@components/common/Loader';
import {
  removeItemFromCart,
  pushCartItemsInfo,
  pushItemQuantityToCart,
  setPaymentCheck,
  addChecks,
  editCartItem,
  deleteItm,
  priceCheck,
  setSeat,
  removeSeat,
  clearCart,
  removePaymentCheck,
  checkVoid,
  enableStartOverBtn
} from '@reducers/orders';
import {
  updateChecksAfterResponse,
} from '@reducers/storeChecks';
import {
  clearAuthResponse
} from '@reducers/payment';
import { APP_CONFIG, SUCCESS_MESSAGE } from '@constants';
import {
  setNotification
} from '@reducers/notification';
import { getObjectValue } from '@utility/utills';
import { flowType } from '@utility/userInfo';
import { LABEL } from '../../veriables';


const KioskCart = (props) => {

  // Props Destructuring

  const {enableStartOverBtn, cart, check, deviceInfo, userInfo, updateChecksAfterResponse, deleteItm, setNotification, pushCartItemsInfo, addChecks, 
  editCartItem, auth, setPaymentCheck, priceCheck, setSeat, checkVoid, clearCart, removeSeat, clearAuthResponse, removePaymentCheck, authResponse, menuItemId } = props;

  // React Hooks

  useEffect(() => {
    enableStartOverBtn(true)
  }, [])

  // Methods

  const onRemoveItemFromCart = (internalId) => {
    const cartItem = cart.find((e) => e.internalId === internalId);
    const dataToSend = {
      checkHeaderId: check.id,
      deviceId: deviceInfo.deviceId,
      employeeCard: getObjectValue(() => userInfo.employeeCard, null),
      employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      items: [{ checkOrderItemId: cartItem.id }],
      storeId: deviceInfo.storeId
    };
    deleteItm(dataToSend).then((res) => {
      updateChecksAfterResponse(res);
      setNotification({
        type: 'success',
        message: SUCCESS_MESSAGE.ITEM_DELETE_SUCCESS
      });
    }).catch(() => {
      setNotification({
        type: 'danger',
        message: SUCCESS_MESSAGE.ITEM_DELETE_FAIL
      });
    });
    pushCartItemsInfo();
  };

  const changeItemQuantity = (quantity, internalId) => {
    if (quantity > 0) {
      const cartItem = cart.find((e) => e.internalId === internalId);
      const cartItemToUpdate = check.orders[0].items.find((e) => e.id === cartItem.id);
      const modifierJson = JSON.parse(JSON.parse(cartItemToUpdate.orderJson).modifierJson);
      const requestData = {
        ...modifierJson,
        quantity,
      };
      requestData.modifierJson = JSON.stringify(requestData);
      const itemInfoObj = {
        ...requestData,
        seatIds: [],
        modifiers: modifierJson.modifierObject,
        suppressNote: false,
        openPrice: null,
        ageRestricted: false,
        checkOrderItemId: cartItem.id
      };
      const dataToSendToAdd = {
        storeId: deviceInfo.storeId,
        employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
        deviceId: deviceInfo.deviceId,
        checkHeaderId: check.id,
        items: [itemInfoObj],
        employeeCard: getObjectValue(() => userInfo.employeeCard, null),
        orderJson: JSON.stringify(itemInfoObj),
        longitude: '0',
        latitude: '0',
        geoLocation: '0'
      };
      addChecks(dataToSendToAdd, 'update').then((res) => {
        updateChecksAfterResponse(res);
        const cartData = {
          ...requestData,
          id: cartItem.id,
        };
        editCartItem(cartData);
      });
    } else {
      onRemoveItemFromCart(internalId);
    }
  };

  const onModifyItem = (data, type) => {
    props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/order-item/${data.menuTypeId}/${data.menuItemId}/${data.internalId}/1?menuId=${data.menuId}&&checkItem=${data.id}&&type=${type}`);
  };

  const getSubTotalAmount = (table) => {
    return auth.country === 1 ? +(table.itemAmount) : +(table.totalAmount);
  };

  const goToOrder = () => {
    props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/orders`);
  };

  const getTotalAmount = (table) => {
    const discount = getObjectValue(() => table.discountAmount, 0);
    const serviceCharge = getObjectValue(() => table.serviceChargeAmount, 0);
    return auth.country === 1 ? +(table.itemAmount + table.taxAmount + serviceCharge - discount) : +(table.totalAmount - discount);
  };

  const goToPayment = () => {
    setPaymentCheck({ ...check, subTotalAmount: getSubTotalAmount(check), totalAmount: getTotalAmount(check) }).then(() => {
      props.history.replace(`${APP_CONFIG.BASE_URL}/pay`);
    });
  };

  const getBtnName = () => {
    const value = Object.keys(getObjectValue(() => deviceInfo.deviceGroup.paymentTypes, [])).find((v) => deviceInfo.deviceGroup.paymentTypes[v]);
    switch (value) {
      case 'creditCard': return { key: 'card', label: LABEL().PAY_WITH_CARD };
      case 'cash': return { key: 'cash', label: LABEL().PAY_WITH_CASH };
      case 'scanToPay': return { key: 'scan', label: LABEL().SCAN_TO_PAY };
      case '':return { key: 'card', label: LABEL().PAY_WITH_CARD };
      default: return { };
    }
  };

  const paymentBtn = () => {
    let btnName = {  };
    if (deviceInfo.deviceGroup == null) {
      btnName = { key: 'card', label: LABEL().PAY_WITH_CARD };
    }
    if (getObjectValue(() => deviceInfo.deviceGroup.paymentTypes, false) && Object.keys(getObjectValue(() => deviceInfo.deviceGroup.paymentTypes, [])).filter((v) => deviceInfo.deviceGroup.paymentTypes[v]).length > 1) {
      btnName = { key: 'all', label: LABEL().CONTINUE_WITH_PAYMENT };
    } else if (getObjectValue(() => deviceInfo.deviceGroup.paymentTypes, false) && Object.keys(getObjectValue(() => deviceInfo.deviceGroup.paymentTypes, [])).filter((v) => deviceInfo.deviceGroup.paymentTypes[v]).length === 1) {
      btnName = getBtnName();
    }
    return btnName;
  };

  const handleKioskPriceCheck = (key) => {
    const data = getObjectValue(() => check.orders[0].items.reduce((a, v) => {
      if (v.pending) {
        a.push({
          ...v,
          ...JSON.parse(v.orderJson),
          menuScreenId: getObjectValue(() => JSON.parse(JSON.parse(v.orderJson).menuScreenId), 0),
          menuId: getObjectValue(() => JSON.parse(JSON.parse(v.orderJson).menuId), 0)
        });
      }
      return a;
    }, []), []);
    let subtotalAmount = 0;
    const items = data && data.length > 0 ? data.map((e) => {
      subtotalAmount += e.price;
      return {
        menuItemId: e.menuItemId,
        quantity: e.quantity,
        modifiers: e.modifiers,
        price: e.price,
        note: e.note,
        menuScreenId: e.menuScreenId,
        menuId: e.menuId
      };
    }) : [];
    const dataToSend = {
      deviceId: deviceInfo.deviceId,
      employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      storeId: deviceInfo.storeId,
      checkHeaderId: check.id,
      items,
      subtotalAmount
    };
    priceCheck(dataToSend).then((resData) => {
      setSeat({
        ...check,
        ...resData,
        items: data
      });
      setPaymentCheck({
        ...check,
        ...resData,
        items: data
      }).then(() => {
        switch (key) {
          case 'cash': props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/pay?type=${key}`); break;
          case 'creditCard': props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/pay?type=${key}`); break;
          case 'scanToPay': props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/pay?type=${key}`); break;
          case 'payatcounter': props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/pay?type=${key}`); break;
          default: props.history.replace(`${APP_CONFIG.BASE_URL}/kiosk/pay?type=${key}`); break;
        }
      });
    }).catch((err) => {
      setNotification({
        type: 'danger',
        message: err.message
      });
    });
  };

  const goToLandingPage = () => {
    const dataToSend = {
      employeeId: getObjectValue(() => Number(userInfo.id), JSON.parse(window.sessionStorage.getItem('userInfo')).id),
      storeId: deviceInfo.storeId,
      checkHeaderId: check.id,
      deviceId: deviceInfo.deviceId,
    };
    checkVoid(dataToSend).then(() => {
      clearCart();
      removeSeat();
      clearAuthResponse();
      removePaymentCheck();
      props.history.replace({
        pathname: `${APP_CONFIG.BASE_URL}/${flowType()}`,
      });
    }).catch((e) => {
      setNotification({
        type: 'danger',
        message: e.message
      });
    });
  };

  // HTML CSS Code

  return (
    <>
      {props.loading && <Loader />}
      <Kiosk
        onRemoveItemFromCart={onRemoveItemFromCart}
        goToLandingPage={goToLandingPage}
        authResponse={authResponse}
        cart={menuItemId ? cart.filter((e) => e.menuItemId === menuItemId) : cart}
        goToOrder={goToOrder}
        changeItemQuantity={changeItemQuantity}
        onModifyItem={onModifyItem}
        goToPayment={goToPayment}
        handleKioskPriceCheck={handleKioskPriceCheck}
        paymentBtn={paymentBtn()}
      />
    </>
  );
};

// Redux Part

const mapStateToProps = ({
  orders,
  oauth,
  payment
}) => ({
  loading: orders.loading,
  cart: orders.cart,
  check: orders.seats,
  auth: oauth.authInfo,
  userInfo: oauth.loggedInUserData,
  authResponse: payment.authResponse,
  deviceInfo: oauth.deviceInformation,
  pymtType: payment.pymtType
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  removeItemFromCart,
  pushCartItemsInfo,
  pushItemQuantityToCart,
  setPaymentCheck,
  addChecks,
  editCartItem,
  updateChecksAfterResponse,
  deleteItm,
  setNotification,
  priceCheck,
  setSeat,
  removeSeat,
  clearCart,
  clearAuthResponse,
  removePaymentCheck,
  checkVoid,
  enableStartOverBtn
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(KioskCart);
